<template>
  <svg :class="className" :width="width" :height="height">
    <use :xlink:href="href" />
  </svg>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    className: {
      type: String,
      default: null
    },
    glyph: {
      type: String,
      default: null
    },
    height: {
      type: Number,
      default: null
    },
    width: {
      type: Number,
      default: null
    }
  },
  computed: {
    href() {
      return `#${this.glyph}`;
    }
  }
};
</script>
